var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("CollapseResource", {
        attrs: {
          title: "教师成长",
          actionUrl: "/resourceResearch",
          sortDictCode: "teacher_growth_sort",
          isShowSort: true,
          actionType: "3",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }